import React from 'react'
import ReactLoading from 'react-loading'

import './loader.css'

const Loader = (props) => {
  // options: https://www.npmjs.com/package/react-loading
  const type = 'spinningBubbles'
  const color = props.color || '#00f'

  return (
    <div>
      <div className='loader__wrapper'>
        <ReactLoading
          type={type}
          color={color}
          height={50}
          width={50} />
      </div>
    </div>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/index.js